(ns ^:dev/always bp-clients.tv-app.api.graphql.page
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/media/page.graphql"
  "graphql/media/list-page.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private page-raw (get-in query-map [:query :page]))
(def ^:private list-page-raw (get-in query-map [:query :tv-app-list-page]))

(defn page-query
  "Sends a token-valid query"
  [page-slug]
  (query-builder page-raw {:page-slug (name page-slug)}))

(defn list-page-query
  "Sends a token-valid query"
  [page-slug]
  (query-builder list-page-raw {:slug (name page-slug)}))

(comment
  ;; see the corresponding .graphql files for more impormation
  (page-query :home-new-bg)

  (list-page-query :home-new-bg)

  nil)
